import api from '../utils/api';

export interface CategoryTag {
  tag: string;                   // e.g., 'HSW', 'Ethics'
  displayName: string;           // e.g., 'Health, Safety & Welfare'
  description?: string;
}

export interface StateNote {
  stateIDs: number[];
  message: string;
  redirectProfessionID?: string;
}

export interface Profession {
  _id: string;
  professionID: string; // e.g., 'ARCH', 'PE', 'LA'
  name: string; // e.g., 'Architect', 'Professional Engineer'
  description?: string; // Optional description
  creditTerminology: string; // e.g., 'LU', 'PDH', 'CE'
  validCategoryTags: CategoryTag[]; // Available category tags for this profession
  isActive?: boolean; // Whether the profession is active
  order?: number;
  stateNotes?: StateNote[]; // Per-state credential naming advisories
}

export const getAllProfessions = async (): Promise<Profession[]> => {
  const response = await api.get('/api/professions');
  return response.data;
};

export const createProfession = async (data: Omit<Profession, '_id'>): Promise<Profession> => {
  const response = await api.post('/api/professions', data);
  return response.data;
};

export const updateProfession = async (id: string, data: Partial<Profession>): Promise<Profession> => {
  const response = await api.put(`/api/professions/${id}`, data);
  return response.data;
};

export const deleteProfession = async (id: string): Promise<void> => {
  await api.delete(`/api/professions/${id}`);
};
